import VueExcelXlsx from 'vue-excel-xlsx'
import Vue from 'vue'

Vue.use(VueExcelXlsx)
